import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { Description } from "@ui/components/containers/description";
import { Subtitle } from "@ui/components/containers/title";
import { WarningIcon } from "@ui/components/icons";
import { ClosableModal } from "@ui/modals/closableModal";
import { gap, mobile } from "@ui/styles/utils";

interface AdministratorLimitModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
}
export const AdministratorLimitModal: React.FC<AdministratorLimitModalProps> = ({ close, ...htmlProps }) => {
	return (
		<Container close={close} {...htmlProps}>
			<WarningCercle>
				<WarningIcon width={48} style={{ position: "absolute", top: 75, marginLeft: 25 }} />
			</WarningCercle>
			<Subtitle>{I18n.t("shareroom.administrator.limit_reached_modal.title")}</Subtitle>
			<Description>{I18n.t("shareroom.administrator.limit_reached_modal.description")}</Description>
			<Actions>
				<PrimaryButton onClick={close}>{I18n.t("noted")}</PrimaryButton>
			</Actions>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	${gap(25)};
	align-items: center;
	text-justify: center;
	align-content: justify;
	width: 500px;
`;

const Actions = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	flex-direction: column;
	${gap(25)};

	@media ${mobile} {
		${gap(15)};
		> button {
			padding: 12px 20px;
		}
	}
`;
const WarningCercle = styled.div`
	background-color: ${({ theme }) => theme.colors.lightRed};
	height: 100px;
	width: 100px;
	border-radius: 50px;
`;
